import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import Heading from "../../../component/Heading/Heading";
import DashboardCard from "./DashboardCard";
import invoiceIcon from "../../../assets/icons/invoice.svg";
import groupIcon from "../../../assets/icons/group.svg";
import verbindlichkeitenIcon from "../../../assets/icons/verbindlichkeiten.svg";
import darlehenIcon from "../../../assets/icons/darlehen.svg";

import { useTranslation } from "react-i18next";
import DashboardChart from "./DashboardChart";
import { getDashboardDataList } from "../../../services/customer-services/customerDashboardService";
import { useEffect, useState } from "react";
import { formatGermanPercentage } from "../../../helper/formatAmount";
import { getLiquiditätsbilanz2List } from "../../../services/customer-services/customerLiquiditätsbilanz";
import "../../../styles/pages/customer/dashboard.scss";
import CrifScoreCard from "./CrifScoreCard";
import { getManualCrifScore } from "../../../services/customer-services/crifService";

const Dashboard = () => {
  const { t } = useTranslation();
  const [dashboardData, setDashboardData] = useState({});
  const [totals, setTotals] = useState({});
  const [crifScore, setCrifScore] = useState(null); // New state for Crif Score
  const [lastCrifUpdate, setLastCrifUpdate] = useState(null);
  const [isCrifLoading, setIsCrifLoading] = useState(true);

  const data = [
    {
      icon: invoiceIcon,
      name: "dashboard_verrechnungssaldo",
      total: dashboardData?.verrechnungssaldo ?? 0,
    },
    {
      icon: groupIcon,
      name: "forderungen_heading",
      total: dashboardData?.forderungen ?? 0,
    },
    {
      icon: verbindlichkeitenIcon,
      name: "verbindlichkeiten_heading",
      total: dashboardData?.verbindlichkeiten ?? 0,
    },
    {
      icon: darlehenIcon,
      name: "dashboard_darlehen",
      total: dashboardData?.darlehnen ?? 0,
    },
  ];

  const getDashboardData = async () => {
    const response = await getDashboardDataList();
    if (response?.isSuccess) {
      setDashboardData({ ...response.data });
    } else {
      setDashboardData({});
    }
  };

  const getLiquiditätsbilanz = async () => {
    const response = await getLiquiditätsbilanz2List();
    if (response?.isSuccess) {
      setTotals(response?.totals);
    } else {
      setTotals({});
    }
  };

  const fetchCrifScore = async () => {
    setIsCrifLoading(true);
    const response = await getManualCrifScore();
    if (response?.isSuccess) {
      console.log(response);
      setCrifScore(response.crifScore);
      setLastCrifUpdate(response.lastUpdated);
    }
    setIsCrifLoading(false);
  };

  useEffect(() => {
    getDashboardData();
    getLiquiditätsbilanz();
    fetchCrifScore(); // Fetch Crif Score
  }, []);

  const totalRatio =
    totals?.totalPassivaWert && totals.totalPassivaWert !== 0
      ? (totals.totalAktivaWert / totals.totalPassivaWert) * 100
      : 0;

  return (
    <div className="dashboard-wrapper">
      <div className="dashboard-heading flex items-center justify-between">
        <Heading text={t("module_dashboard")} className="heading" />
      </div>
      <Grid container sx={{ marginTop: "0rem" }} spacing={3.5}>
        {data?.map((item, index) => (
          <Grid item xs={12} sm={12} md={6} lg={4} xl={3} key={index}>
            <DashboardCard item={item} t={t} />
          </Grid>
        ))}
      </Grid>
      <Box>
        <Grid container sx={{ marginTop: "0rem" }} spacing={3.5}>
          {/* Liquiditätsbilanz Card - Adjusted to md={8} */}
          <Grid item xs={12} md={8}>
            <Card
              variant="outlined"
              sx={{
                background: "#fff",
                height: "100%",
                padding: "10px",
                borderRadius: "10px",
              }}
            >
              <CardContent sx={{ background: "#fff" }}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography>{t("dashboard_liquiditatbianz")} 1</Typography>
                  <Typography>
                    {formatGermanPercentage(dashboardData?.liquiditatbianzOne)}%
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    paddingTop: "10px",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography>{t("dashboard_liquiditatbianz")} 2</Typography>
                  <Typography>{formatGermanPercentage(totalRatio)}%</Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>

          {/* Crif Score Card - New addition md={4} */}
          <Grid item xs={12} md={4}>
            <CrifScoreCard
              score={crifScore}
              lastUpdated={lastCrifUpdate}
              isLoading={isCrifLoading}
              onRefresh={fetchCrifScore}
            />
          </Grid>
        </Grid>
      </Box>
      <Box>
        <DashboardChart />
      </Box>
    </div>
  );
};

export default Dashboard;
